/* unplugin-vue-components disabled */import script from "./ModuleTenant.vue?vue&type=script&setup=true&lang=js"
export * from "./ModuleTenant.vue?vue&type=script&setup=true&lang=js"

import "./ModuleTenant.vue?vue&type=style&index=0&id=49343e00&lang=scss&scoped=true"

import exportComponent from "D:\\igencloud_team\\ident-doc-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49343e00"]])

export default __exports__